import { defineComponent as _defineComponent } from 'vue'
import BoxGridItem from '@/app/components/common/boxGrid/BoxGridItem.vue';
import { BoxGridItemProps } from './interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'BoxGridBlock',
  props: {
  ...BoxGridItemProps,
  itemClass: {
    type: String,
    default: 'card-block',
  },
  title: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, BoxGridItem }
}

})